module.exports = __webpack_public_path__ + "img/youmu konpaku_sc1.d68abc68.png";